const products = [
    {
        id: 0,
        inCart: 0,
        images: [
            {
                img: "https://static.tildacdn.com/tild3533-6535-4363-a337-613438356632/2394b4eccecd20126b20.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3533-6535-4363-a337-613438356632/2394b4eccecd20126b20.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3533-6535-4363-a337-613438356632/2394b4eccecd20126b20.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3533-6535-4363-a337-613438356632/2394b4eccecd20126b20.jpg",
            },
        ],
        title_uz: "Bolalar savatchasi (Люлька)",
        title_ru: "Детская корзина (Люлька)",
        desc_uz: `Ayni sizning didingizga mos istalgan ranglar! Yetkazib berish xizmati 5 kun  ichida amalga oshiriladi!`,
        desc_ru: `Любые цвета на ваш вкус! Доставка осуществляется за 5 дней!`,
        price: 600000,
        oldPrice: 1000000,
    },
    {
        id: 1,
        inCart: 0,
        images: [
            {
                img: "https://static.tildacdn.com/tild3231-3933-4466-b430-633661633632/2.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3231-3933-4466-b430-633661633632/2.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3231-3933-4466-b430-633661633632/2.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3231-3933-4466-b430-633661633632/2.jpg",
            },
        ],
        title_uz: "Issiq qalpoqchalar!",
        title_ru: "Горячие шапки!",
        desc_uz: `Ayni sizning didingizga mos istalgan ranglar! Yetkazib berish xizmati 5 kun ichida amalga oshiriladi!`,
        desc_ru: `Любые цвета на ваш вкус! Доставка осуществляется за 4 дня!`,
        price: 250000,
        oldPrice: 500000,
    },
    {
        id: 2,
        inCart: 0,
        images: [
            {
                img: "https://static.tildacdn.com/tild3964-6230-4135-a233-396561613035/photo_2022-09-15_14-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3964-6230-4135-a233-396561613035/photo_2022-09-15_14-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3964-6230-4135-a233-396561613035/photo_2022-09-15_14-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3964-6230-4135-a233-396561613035/photo_2022-09-15_14-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3964-6230-4135-a233-396561613035/photo_2022-09-15_14-.jpg",
            },
        ],
        title_uz: "Yangi tug'ilgan chaqaloqlar uchun kombinezonlar!",
        title_ru: "Комбинезоны для новорожденных!",
        desc_uz: `Ayni sizning didingizga mos istalgan ranglar! Yetkazib berish xizmati kun ichida amalga oshiriladi!`,
        desc_ru: `Любые цвета на ваш вкус! Доставка осуществляется за 7 дня!`,
        price: 450000,
    },
    {
        id: 3,
        inCart: 0,
        images: [
            {
                img: "https://static.tildacdn.com/tild3161-6362-4630-a632-383237393561/photo_2022-11-21_22-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3161-6362-4630-a632-383237393561/photo_2022-11-21_22-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3161-6362-4630-a632-383237393561/photo_2022-11-21_22-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3161-6362-4630-a632-383237393561/photo_2022-11-21_22-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3161-6362-4630-a632-383237393561/photo_2022-11-21_22-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3161-6362-4630-a632-383237393561/photo_2022-11-21_22-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3161-6362-4630-a632-383237393561/photo_2022-11-21_22-.jpg",
            },
        ],
        title_uz: "GILAMCHA",
        title_ru: "Пледы",
        desc_uz: `Didingizga mos har qanday rangda! 6 kungacha yetkazib berish!`,
        desc_ru: `В любом цвете на ваш вкус! Доставка до 6 дней!`,
        price: 400000,
        oldPrice: 8000000,
    },
    {
        id: 4,
        inCart: 0,
        images: [
            {
                img: "https://static.tildacdn.com/tild3662-3530-4164-a434-646262306138/photo_2022-11-21_23-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3662-3530-4164-a434-646262306138/photo_2022-11-21_23-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3662-3530-4164-a434-646262306138/photo_2022-11-21_23-.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3662-3530-4164-a434-646262306138/photo_2022-11-21_23-.jpg",
            },
            {
                img: "https://action.com/hostedassets/CMSArticleImages/91/27/2546873_8714333010286-111_01_20221122192651.png",
            },
            {
                img: "https://static.tildacdn.com/tild3662-3530-4164-a434-646262306138/photo_2022-11-21_23-.jpg",
            },
        ],
        title_uz: "To'qilgan ryukzaklar!",
        title_ru: "Плетеные рюкзаки!",
        desc_uz: `Didingizga mos har qanday rangda! 6 kungacha yetkazib berish!`,
        desc_ru: `В любом цвете на ваш вкус! Доставка до 6 дней!`,
        price: 300000,
    },
    {
        id: 5,
        inCart: 0,
        images: [
            {
                img: "https://static.tildacdn.com/tild3864-3039-4432-a233-326430313430/8890515dc1c0900d882f.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3864-3039-4432-a233-326430313430/8890515dc1c0900d882f.jpg",
            },
            {
                img: "https://static.tildacdn.com/tild3864-3039-4432-a233-326430313430/8890515dc1c0900d882f.jpg",
            },
        ],
        title_uz: "Yangi tug'ilgan chaqaloqlar uchun Penetki",
        title_ru: "Пенетки для новорожденных",
        desc_uz: `Didingizga mos har qanday rangda! 6 kungacha yetkazib berish!`,
        desc_ru: `В любом цвете на ваш вкус! Доставка до 6 дней!`,
        price: 100000,
        oldPrice: 200000,
    },
]


module.exports = products
